export enum WidgetTypesEnum {
    DeviceStatus = 1,
    UpdateStatus = 2,
    DeviceCount = 3,

    CashCount = 4,
    CashDistribution = 5,
    Transactions = 6,

    InstallationSummary = 7,
    InstallationsStatusChanges = 8,
}
